module.exports = __webpack_public_path__ + "static/media/wordle.9d34b168.jpg";